module.exports = __webpack_public_path__ + "img/book2.05515c4b.png";